module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"attention":"Achtung","confirm delete slide":"Der Inhalt dieser Seite wird gelöscht. Fortfahren?","copy of":"Kopie von {title}","soft limit slides reached":"Die empfohlene Anzahl an Seiten ({limit}) ist überschritten..."}}')
  delete Component.options._Ctor
}
